module.exports = __webpack_public_path__ + "img/userC04.9ac99770.jpg";